<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.link"
            id="fundsMonthlyTransItemLinkText"
            class="funds-monthly-trans-item-link-text"
            label="Link"
            @blur="somethingChanged"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.saiSection"
            id="fundsMonthlyTransItemSAISectionText"
            class="funds-monthly-trans-item-sai-section-text"
            label="SAI Section"
            @blur="somethingChanged"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.line"
            id="fundsMonthlyTransItemLineText"
            class="funds-monthly-trans-item-line-text"
            label="Line"
            @blur="somethingChanged"
            @keydown.enter="somethingChanged"
            readonly
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.balanceLastMonth"
            id="fundsMonthlyTransItemBalanceLastMonthtText"
            class="funds-monthly-trans-item-balance-last-month-text"
            label="Balance Last Month"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.apportioned"
            id="fundsMonthlyTransItemApportionedText"
            class="funds-monthly-trans-item-apportioned-text"
            label="Apportioned"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.transferIn"
            id="fundsMonthlyTransItemTransferInText"
            class="funds-monthly-trans-item-transfer-in-text"
            label="Transfer In "
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.transferOut"
            id="fundsMonthlyTransItemransferOutText"
            class="funds-monthly-trans-transfer-out-text"
            label="Transfer Out"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.disbursements"
            id="fundsMonthlyTransItemPaymentDisbursedText"
            class="funds-monthly-trans-refunds-payment-disbursed-text"
            label="Payment disbursed"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.od"
            id="fundsMonthlyTransItemODText"
            class="funds-monthly-trans-item-od-text"
            label="Official Deposits"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.balance"
            id="fundsMonthlyItemBalanceText"
            class="funds-monthly-trans-item-balance-text"
            label="Balance"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';

const amountFields = ['balanceLastMonth', 'apportioned', 'transferIn', 'transferOut', 'disbursements', 'od', 'balance', 'saiSection'];

export default {
  name: 'FundsMonthlyTransaction',
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'fundsMonthlyTrans-dialog',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    editedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    roundAmountFields() {
      return amountFields.forEach((f) => {
        this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
      });
    },
  },
};
</script>
